import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Hopkins from '../../img/agenda/Hopkins.png'
import nvidia from '../../img/agenda/nvidia.png'
import packetfabric from '../../img/agenda/packetfabric.png'
import Tomlinson from '../../img/agenda/Tomlinson.png'
import Webb from '../../img/agenda/Webb.png'
import Wolant from '../../img/agenda/Wolant.png'
import Clifford from '../../img/agenda/Clifford.png'
import InfluxData from '../../img/agenda/InfluxData.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:10',
                    photo: Clifford,
                    name: 'Jay Clifford',
                    position: 'Developer Advocate',
                    logo: InfluxData,
                    title: 'Building an IoT App with InfluxDB, Python, Flask And Plotly',
                    abstract: `The Internet of Things (IoT) is increasingly driven by sensor data, with devices taking measured actions based on everything from wind speed and direction, vital body functions, illumination intensity, and temperature.

                    In this session, we will showcase how to build a fully functional sample IoT monitoring application built on InfluxDB. With functions such as visualization and creating alerts from uploaded sensor data in a custom user experience.`,
                },
                {
                    time: '09:40',
                    photo: Tomlinson,
                    name: 'Jacob Tomlinson',
                    position: 'Senior Software Engineer',
                    ln: 'https://www.linkedin.com/in/jacob-tomlinson-084b6734/',
                    tw: 'https://twitter.com/_jacobtomlinson',
                    github: 'https://github.com/jacobtomlinson',
                    logo: nvidia,
                    title: 'Intro to GPU Development in Python',
                    abstract: `Writing code for GPUs has come a long way over the last few years and it is now easier than ever to get started. You can even do it in Python! This talk will cover setting up your Python environment for GPU development. How coding for GPUs differs from CPUs, and the kind of problems GPUs excel at solving. We will dive into some real examples using Numba and also touch on a suite of Python Data Science tools called RAPIDS.`,
                },
                {
                    time: '10:10',
                    photo: Webb,
                    name: 'Brad Webb',
                    position: 'Senior Analytics Consultant',
                    ln: 'https://www.linkedin.com/in/brad-webb-101/',
                    github: 'https://github.com/BradWebb101',
                    title: 'using S3 - in Analytics/Data science (Python)',
                    abstract: `Cloud computing is become more common in Analytics and Data science. I would like to explore the possibilities of AWS s3 and Python Lambda functions to simplify common tasks, such as transforming excel to csv, aggregating files, renaming files to conform to a naming convention.`,
                },
                {
                    time: '10:40',
                    photo: Hopkins,
                    name: 'Adam Hopkins',
                    position: 'Director of Software Engineering',
                    ln: 'https://www.linkedin.com/in/ahopkins/',
                    tw: 'https://twitter.com/AdmHpkns',
                    github: 'https://github.com/ahopkins',
                    logo: packetfabric,
                    title: 'Mayim: Bring Your Own Query - Intro to the non-ORM SQL client',
                    abstract: `ORMs are great, except when they are not. Ever been working with an ORM and feel like you need to jump through hoops to get the queries you want? But, you do not want to dropdown to the low-level clients and give up your nicely annotated models.

                  This is where Mayim fits in. The DB client that executes your hand-written SQL queries, and hydrates them into models.
                  
                  In this talk we will cover:
                  - the benefits to writing your own SQL
                  - how Mayim can be used to handle complex data models
                  - integration options into web frameworks like Sanic`,
                },
                {
                    time: '11:10',
                    photo: Wolant,
                    name: 'Albert Wolant',
                    position: 'Software Development Engineer',
                    ln: 'https://www.linkedin.com/in/albert-wolant/',
                    logo: nvidia,
                    title: 'Offload Data Preprocessing to the GPU with Python and NVIDIA DALI',
                    abstract: `I will show how to use Python and NVIDIA DALI to offload data preprocessing to the GPU in a Deep Learning workflow with just a few lines of code. 
                  I will discuss why and when this technique is beneficial and show speedups in real world examples. 
                  Attendees will learn how to use advanced features of the GPU like hardware accelerated image and video decoding or optical flow calculation using Python.
                  After the talk attendees will be able to apply presented concepts to their own neural network training.`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone <span className='num'>0</span> UTC</p>
                    <p className="agenda_undertitle">September <span className='num'>6 09:00 - 22:10</span></p>
                    <p className="agenda_day">Junior Track</p>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/python' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};